import { ICustomBinding } from "#/DefaultViewExtensionInterfaces";

export default class ControlsBinding implements ICustomBinding {

    public initBinding() {
        ko.bindingHandlers.controls = {
            update: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let value = valueAccessor();
                let controls = ko.unwrap(value);

                if (!controls) {
                    return;
                }

                // Falls das Element noch keine ID besitzt, wird diese anhand des darüberliegenden Controls erzeugt
                if (!controls.attr('id')) {
                    controls.attr('id', _.uniqueId())
                }

                element.removeAttr('aria-controls');
                element.attr('aria-controls', controls.attr('id'));
            }
        };
    }
}